'use strict';

/**
 *
 * @name: addonQuotation
 *
 */

import DirectiveTemplate from './nn-addon-quotation.directive.html';
import './nn-addon-quotation.directive.scss';

function AddonQuotationDirective() {

  'ngInject';

  return {
    restrict: 'C',
    replace: true,
    scope: true,
    template: DirectiveTemplate,
    link: function(scope, element, attrs) {

      scope.quotationText = attrs.quotation ? attrs.quotation : scope.post.translations[scope.$root.lang].quote;
    }
  };
}

export default AddonQuotationDirective;



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/nn-addon-quotation/nn-addon-quotation.directive.js